module.exports = __webpack_public_path__ + "static/media/Eb4.45db68f4.mp3";